import { apiRoutes, fetchJson } from "@/src/services";
import { Button } from "@mui/material";
import { useCallback } from "react";
import { useRecordContext } from "react-admin";


const batchEmails = async (batchId: string, data?: any) => {
    const resp = await fetchJson(`${apiRoutes.batchEmails}`, { method: 'POST', mode: 'cors', body: JSON.stringify({ batchId, ...data }) })
    console.log(resp)
    return resp;
}

export const ActivateBulkButton = (props: any) => {

    const record = useRecordContext(props)
    const handleClick = useCallback((e: any) => {
        if (record) {
            e.stopPropagation();

            if (confirm("Are you sure ?")) {
                batchEmails(`${record.id}`)
            }
        }
    }, [record])

    return record ? (
        <Button
            
            size='small'
            variant="outlined"
            color="primary"
            onClick={handleClick}
        >
            Send Bulk
        </Button>
    ) : null;
};